// extracted by mini-css-extract-plugin
module.exports = {"loader":"NewSpinner-module--loader--24qVx","spinner":"NewSpinner-module--spinner--2HB7Q"};